"use client";

import React from "react";
// import NextLink from "next/link";
import { Link as NextIntlLink } from "@/lib/intlNavigation";

import useAnalytics from "@/hooks/useAnalytics";

const Link = ({
  track: trackProps = {},
  children,
  onClick = () => {},
  href,
  disabled = false,
  ...props
}) => {
  const { track } = useAnalytics();

  const handleClick = React.useCallback(
    (e) => {
      // e.preventDefault();
      if (typeof onClick === "function") {
        onClick();
      }

      if (trackProps?.event) {
        track(trackProps.event, trackProps.meta);
      }
    },
    [onClick, trackProps, track],
  );

  if (disabled) {
    return (
      <button disabled {...props}>
        {children}
      </button>
    );
  }

  return (
    <NextIntlLink href={href} onClick={handleClick} prefetch={false} {...props}>
      {children}
    </NextIntlLink>
  );
};

export default Link;
